import { useTranslation } from 'next-i18next'
import NewShell from './NewShell'
import ServiceHero from './service-new/ServiceHero'
import CoreServices from './service-new/CoreServices'
import ServiceFeatures from './service-new/ServiceFeatures'
import HelpBanner from './service-new/HelpBanner'
import BusinessSolutions from './service-new/BusinessSolutions'
import ServiceFaq from './service-new/ServiceFaq'

// NEW-design (?new) variant of pages/service.js — a full redesign built to the
// service mockup (new-design-service). The old /service page (no ?new) keeps
// its own inline content untouched via the guard in pages/service.js. All
// chrome (HeaderNew + FooterNew + Sukhumvit webfont) comes from NewShell.
const ServiceNew = () => {
  const { t } = useTranslation('services')
  return (
  <NewShell
    title={t('new.meta.title')}
    keywords={t('new.meta.keywords')}
    description={t('new.meta.description')}
    headExtra={
      // Preload the LCP hero (now a ~36 KB webp) so it starts before the
      // <img> is parsed — collapses the previously 28s LCP on this page.
      <link
        rel="preload"
        as="image"
        href="/static/img/service-new/v2/hero/banner.webp"
        type="image/webp"
        fetchpriority="high"
      />
    }
  >
    <ServiceHero />
    <CoreServices />
    <ServiceFeatures />
    <HelpBanner />
    <BusinessSolutions />
    <ServiceFaq />
  </NewShell>
  )
}

export default ServiceNew
